export default __webpack_public_path__ + "static/media/qi-empirical.e78edb43.jpg";